import { CompanyData } from '../../types/CompanyData';
import { AccountSourceId } from '../../types/AccountSources';
import { PhoneNumber } from "../../../../ui/gzPhoneInput/types";

export interface ADUser {
  _id: string;
  email: string;
  fullName: string;
  userName: string;
}

export interface LanguageData {
  id: string;
  title: string;
}

export interface TimezoneData {
  id: string;
  value: string;
}

export enum AccountDetailsEvents {
  COMPANY_SELECTION_CHANGED = 'companySelectionChanged',
  CHANGE_ACCOUNT_SOURCE = 'changeAccountSource',
  RESYNC_AD_IN_PROGRESS = 'resyncADInProgress',
  RESYNC_AD_DONE = 'resyncADDone',
}

export interface Company {
  id: string;
  name: string;
}

export interface AccountDetails {
  _id?: string;
  userName?: string;
  email?: string;
  adIntegration?: boolean;
  source?: AccountSourceId;
  profile?: {
    timezone?: string;
    language?: string;
    fullName?: string;
  };
  phoneNumber?: PhoneNumber;
  companyInfo: CompanyData;
  timezoneOptions?: TimezoneData[];
  languageOptions?: LanguageData[];
}

export interface ADUserSelectorType {
  label: string;
  value: string;
  email: string;
  fullName: string;
}
